import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  return <section id="inicio" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-187">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-188">
        <img src="https://i.imgur.com/Mqr91Wv.jpeg" alt="Piscina remodelada en Central Florida" className="w-full h-full object-cover object-center" data-id="element-189" />
        <div className="absolute inset-0 bg-navy-900/60 mix-blend-multiply" data-id="element-190"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/80 via-transparent to-navy-900/90" data-id="element-191"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-192">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto" data-id="element-193">
          <span className="inline-block py-1 px-3 rounded-full bg-pool-500/20 border border-pool-500/50 text-pool-100 font-semibold text-sm tracking-wider uppercase mb-6 backdrop-blur-sm" data-id="element-194">
            Expert Pool Renovations in Central Florida
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white leading-tight mb-6 drop-shadow-lg" data-id="element-195">
            Remodele su Piscina y Obtenga{' '}
            <span className="text-gold-400" data-id="element-196">2-3 Meses</span> de Mantenimiento
            Gratis
          </h1>

          <p className="text-lg md:text-2xl text-gray-200 mb-10 font-light drop-shadow-md max-w-2xl mx-auto" data-id="element-197">
            Crystal clear water guaranteed. Transformamos su piscina con
            expertos certificados y tecnología de punta.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-198">
            <a href="#contacto" className="w-full sm:w-auto bg-gold-500 hover:bg-gold-600 text-white font-bold text-lg py-4 px-8 rounded-full transition-all shadow-[0_0_20px_rgba(212,168,67,0.4)] hover:shadow-[0_0_30px_rgba(212,168,67,0.6)] hover:-translate-y-1" data-id="element-199">
              Agende su Inspección Gratuita
            </a>
            <a href="#servicios" className="w-full sm:w-auto bg-transparent hover:bg-white/10 text-white border-2 border-white font-semibold text-lg py-3.5 px-8 rounded-full transition-all backdrop-blur-sm" data-id="element-200">
              Conozca Nuestros Servicios
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center" data-id="element-201">
        <span className="text-white/70 text-sm mb-2 font-medium tracking-widest uppercase" data-id="element-202">
          Descubra Más
        </span>
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 1.5,
        ease: 'easeInOut'
      }} data-id="element-203">
          <ChevronDown className="text-white/70" size={24} data-id="element-204" />
        </motion.div>
      </motion.div>
    </section>;
}